import script from "./squares.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./squares.vue?vue&type=script&setup=true&lang=ts"
export * from "./squares.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./squares.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__